import React  from "react";
import './sidebar.css';
import Collapsible from 'react-collapsible';
import Trigger from './Trigger';
import Config from '../../../config/index'
import './simple-sidebar.css'
import ReactGA from 'react-ga4';

let industry = [] ;
let business = [] ;
let application = [] ;
let offeringtype = [] ;
let offeringsub = [ ];

class SidebarSub extends React.Component { 
 

  constructor(props) {
    super(props);
    this.state = {
      leftOpen: true,
      rightOpen: true,
      industryData : industry,
      businessData : business,
      applicationData :application,
      offeringSubData : offeringsub,
      offeringTypeData : offeringtype,
      selectedIndustry : [],
      selectedBusiness : [],
      selectedApplication : [],
      selectedOfferingType : [],
      selectedOfferingSub :[],
      filterList : {},
      industryLabelSelected:[]
    }

    
  }
  
  componentDidMount =() =>{

    fetch(Config.url + "getCategories")
    .then(response => response.json())
    .then(data => {  
     
      if(data != null ) 
      {
        
          if(this.props.setData != null)
          {
             const selected = this.props.setData
                         
            this.setState({
              selectedIndustry: selected.industry,
              selectedBusiness: selected.business,
              selectedApplication: selected.application,
              selectedOfferingSub: selected.offerSub,
              selectedOfferingType: selected.offerType
            })
          }
         
         this.populateIndustryFilter(data.industry)
         this.populateBusinessFilter(data.coreBusiness)
         this.populateApplicationFilter(data.applicationType)
         this.populateProductTypeFilter(data.offerType)
         this.populateProductSubTypeFilter(data.offerSubTypes)
         if(this.props.setIndustryData != null )
          this.setIndustrySelectedByLabel(this.props.setIndustryData)
        
      }   
     
    }).catch((error) => {     
     
    });
    
  }

  populateIndustryFilter = (arr_industry) =>{
    industry = []
    
        if(arr_industry.length > 0)
        {
              arr_industry.map(obj_industry =>{
                if(this.state.selectedIndustry.includes(obj_industry.id))
                industry.push({value:obj_industry.id, label:obj_industry.name, checked:true})
                else
                industry.push({value:obj_industry.id, label:obj_industry.name, checked:false})
            })
           this.setState({industryData : industry})
        }

  }

  populateBusinessFilter = (arr_business) =>{
    business = []
        if(arr_business.length > 0)
        {
              arr_business.map(obj_business =>{
                if(this.state.selectedBusiness.includes(obj_business.id))
                business.push({value:obj_business.id, label:obj_business.name, checked:true})
                else
                business.push({value:obj_business.id, label:obj_business.name, checked:false})
            })
            this.setState({businessData : business})
        }

  }

  populateApplicationFilter = (arr_application) =>{
    application = []
        if(arr_application.length > 0)
        {
              arr_application.map(obj_application =>{
                if(this.state.selectedApplication.includes(obj_application.id))
                application.push({value:obj_application.id, label:obj_application.name, checked:true})
                else
                application.push({value:obj_application.id, label:obj_application.name, checked:false})
            })
            this.setState({applicationData : application})
        }

  }

  populateProductTypeFilter = (arr_productType) =>{

   offeringtype = []
   offeringsub = []

     if(arr_productType.length > 0)
   {
         arr_productType.map(obj_productType =>{

          if(this.state.selectedOfferingType.includes(obj_productType.id))
           offeringtype.push({value:obj_productType.id, label:obj_productType.name, checked:true})
           else
           offeringtype.push({value:obj_productType.id, label:obj_productType.name, checked:false})
          
       })
       this.setState({offeringTypeData : offeringtype})
   }


  }

  populateProductSubTypeFilter = (arr_productSubType) =>{

   
      offeringsub = []
 
      if(arr_productSubType.length > 0)
    {
      arr_productSubType.map(obj_productSubType =>{
        if(this.state.selectedOfferingSub.includes(obj_productSubType.id))
           offeringsub.push({value:obj_productSubType.offerSubTypeId, label:obj_productSubType.name,pid:obj_productSubType.offerTypeId,subTypeId:obj_productSubType.offerSubTypeId, checked:true})
        else
        offeringsub.push({value:obj_productSubType.offerSubTypeId, label:obj_productSubType.name,pid:obj_productSubType.offerTypeId,subTypeId:obj_productSubType.offerSubTypeId, checked:false})

        })       
        this.setState({offeringSubData : offeringsub})
    } 
 
   }

  setIndustrySelectedByLabel = (industry) =>{
     var data = this.state.industryData;
     var selectedValue = []
    if(industry.length == 1)
    {
      data.forEach(function(item) {
    
        if(item.label == industry[0]) {
            item.checked = true;            
        }
        if(item.checked) {
            selectedValue.push(item);
        }        
       
      } );  
      
        this.setState({industryData: data, selectedIndustry : selectedValue,industryLabelSelected:selectedValue})
    }


  }

 

  closeSidebar = (event) => {
   
    this.props.onClose.call()
  }


  onChange(e,type,name) {
  var newData = [];
  var selectedvalues = [];
  switch(type)
  {
    case 1:  newData = this.setData(this.state.industryData,e);          
             selectedvalues = {industry:newData[1],business:this.state.selectedBusiness,application:this.state.selectedApplication,offeringSub:this.state.selectedOfferingSub,offeringType:this.state.selectedOfferingType}
             //selectedvalues =  newData[1].concat(this.state.selectedBusiness,this.state.selectedApplication,this.state.selectedOfferingSub,this.state.selectedOfferingType)
             this.setState({industryData: newData[0], selectedIndustry:newData[1],filterList:selectedvalues});
               
              // this.props.onChange( {strFilter :selectedvalues, industry:newData[1],business: this.state.selectedBusiness,application:this.state.selectedApplication,offerSub:this.state.selectedOfferingSub,offerType:this.state.selectedOfferingType});
             break;
    case 2: newData = this.setData(this.state.businessData,e);
            selectedvalues =  {industry:this.state.selectedIndustry,business:newData[1],application:this.state.selectedApplication,offeringSub:this.state.selectedOfferingSub,offeringType:this.state.selectedOfferingType}
            //selectedvalues = newData[1].concat(this.state.selectedIndustry,this.state.selectedApplication,this.state.selectedOfferingSub,this.state.selectedOfferingType)
            this.setState({businessData: newData[0],selectedBusiness:newData[1],filterList:selectedvalues}); 
            break;
            // this.props.onChange( {strFilter :selectedvalues,industry:this.state.selectedIndustry,business: newData[1],application:this.state.selectedApplication,offerSub:this.state.selectedOfferingSub,offerType:this.state.selectedOfferingType});break;
    case 3: newData = this.setData(this.state.applicationData,e);
            //selectedvalues = newData[1].concat(this.state.selectedIndustry,this.state.selectedBusiness,this.state.selectedOfferingSub,this.state.selectedOfferingType)
             selectedvalues =  {industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:newData[1],offeringSub:this.state.selectedOfferingSub,offeringType:this.state.selectedOfferingType}
            this.setState({applicationData: newData[0], selectedApplication:newData[1],filterList:selectedvalues});
            //this.props.onChange( {strFilter :selectedvalues,industry:this.state.selectedIndustry,business: this.state.selectedBusiness,application:newData[1],offerSub:this.state.selectedOfferingSub,offerType:this.state.selectedOfferingType});break;
             break;
    case 4: newData = this.setData(this.state.offeringSubData,e);
            //selectedvalues = newData[1].concat(this.state.selectedIndustry,this.state.selectedBusiness,this.state.selectedApplication,this.state.selectedOfferingType)
            selectedvalues =  {industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offeringSub:newData[1],offeringType:this.state.selectedOfferingType}
             
            this.setState({offeringSubData: newData[0], selectedOfferingSub:newData[1],filterList:selectedvalues});
            //this.props.onChange( {strFilter :selectedvalues,industry:this.state.selectedIndustry,business: this.state.selectedBusiness,application:this.state.selectedApplication,offerSub:newData[1],offerType:this.state.selectedOfferingType});break;
            break;
    case 5: newData = this.setData(this.state.offeringTypeData,e);
            //this.setAllSubType(e);
           //selectedvalues = newData[1].concat(this.state.selectedIndustry,this.state.selectedBusiness,this.state.selectedApplication,this.state.selectedOfferingSub)
           selectedvalues =  {industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offeringSub:this.state.selectedOfferingSub,offeringType:newData[1]} 
           
           this.setState({offeringTypeData: newData[0], selectedOfferingType:newData[1], filterList:selectedvalues});
            // this.props.onChange( {strFilter :selectedvalues,industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offerSub:this.state.selectedOfferingSub,offerType:newData[1]});break;
            break;    
}
   
    } 


setAllSubType(e)
{

  var selectedValues = [],
  newData = [];
  
  this.state.offeringSubData.forEach(function(item) {
    
    if(item.pid == e.target.value) {
        item.checked = e.target.checked;
        
    }
    if(item.checked) {
        selectedValues.push(item);
    }
    
    newData.push(item);
  } );  
  
  return [newData,selectedValues];


}


setDataSubType(data,e)
{
  var selectedValues = [],
  newData = [];
  data.forEach(function(item) {
    
    if(item.value == e.target.value) {
        item.checked = e.target.checked;        
    }
    
    if(item.checked) {
     
        selectedValues.push(item);        
    }
    
    newData.push(item);
  } );  
  return [newData,selectedValues];
}

setData(data,e)
{
  var selectedValues = [],
  newData = [];
  
   data.forEach(function(item) {
    
    if(item.value == e.target.value) {
        item.checked = e.target.checked;        
    } 
    //build data list   
    newData.push(item);

    //build selected list
    if(item.checked) {
        selectedValues.push(item);
    }
    
   
  } );  
 
  return [newData,selectedValues];

}

//Apply Filters
applyFilters = () =>{

 this.props.onChange( {strFilter :this.state.filterList,industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offerSub:this.state.selectedOfferingSub,offerType:this.state.selectedOfferingType})
 this.state.selectedIndustry.map(ind => {
  ReactGA.send({hitType:'pageview',page:`/search/industry/${ind.label}`})
 })
 //
 this.state.selectedBusiness.map(ind => {
  ReactGA.send({hitType:'pageview',page:`/search/business/${ind.label}`})
 })
 //
 this.state.selectedApplication.map(ind => {
  ReactGA.send({hitType:'pageview',page:`/search/application/${ind.label}`})
 })
 //
 this.state.selectedOfferingSub.map(ind => {
  ReactGA.send({hitType:'pageview',page:`/search/offering/${ind.label}`})
 })

  //
  this.state.selectedOfferingType.map(ind => {
    ReactGA.send({hitType:'pageview',page:`/search/offering/type/${ind.label}`})
   })
}

  // uncheck all items in the list
  uncheckAll = () => {
    
  var newData = [];  
  var industryselection = []
  var filterstr = {}
  
  /*if(this.state.industryLabelSelected.length > 0)
  {
     const industryselected = this.state.industryLabelSelected[0]
      this.state.industryData.forEach(function(item) {   
      if(item.value == industryselected.value) 
      {
        item.checked = true
        industryselection.push(item);
        filterstr = {industry:industryselection,business:[],application:[],offeringSub:[],offeringType:[]}
      }
      else
      item.checked = false;
      newData.push(item);
    });
  }
  else
  {
  this.state.industryData.forEach(function(item) {    
    item.checked = false;
    newData.push(item);
  });
  }                        */

  this.state.industryData.forEach(function(item) {    
    item.checked = false;
    newData.push(item);
  });
 this.setState({industryData: newData});


  newData = [];
  this.state.businessData.forEach(function(item) {
    item.checked = false;
    newData.push(item);
    });
this.setState({businessData: newData});
var newData = [];
  this.state.applicationData.forEach(function(item) {
      item.checked = false;
      newData.push(item);
  });
  this.setState({applicationData: newData});
  var newData = [];
  this.state.offeringSubData.forEach(function(item) {
      item.checked = false;
      newData.push(item);
  });
  this.setState({offeringSubData: newData});
  var newData = [];
  this.state.offeringTypeData.forEach(function(item) {
      item.checked = false;
      newData.push(item);
  });
  this.setState({offeringTypeData: newData});
  this.setState({filterList:filterstr,selectedIndustry:[],selectedBusiness:[],selectedApplication :[],selectedOfferingSub:[],selectedOfferingType:[] },()=>{
    if(this.props.onChange) {
      this.props.onChange({strFilter :this.state.filterList,industry:this.state.selectedIndustry,business:this.state.selectedBusiness,application:this.state.selectedApplication,offerSub:this.state.selectedOfferingSub,offerType:this.state.selectedOfferingType});
  }
  if(this.props.onClear != null)
  this.props.onClear.call()
  })


}


  render(){
  
    return (     
     
           
        <div className="sidebar-content">
          <div className="sticky" style={{paddingBottom:"20px",height:"auto"}}>  
          <div>
            <span style={{fontWeight:"500",fontSize:"18px",paddingLeft:"20px"}}>Filters</span>
            <button className="btn mr-2 align-right" onClick={(e) => this.closeSidebar()}><i className="fa fa-close" style={{fontSize:"20px"}}></i></button>
            </div>        
             <div style={{paddingLeft:"20px"}}>
            <button className="btn-sm btn btn-outline-primary mr-2 " onClick={(e) => this.applyFilters()} >Apply Filters</button>
            <button type="button" className="btn-sm btn btn-outline-primary mr-2 " onClick={(e) => this.uncheckAll()}>Clear All</button>
            </div>
          </div>
          <div>
        
          {this.props.showIndustry !== "false"?
           <Collapsible  trigger={<Trigger text="Industry" /> } open  triggerWhenOpen={<Trigger text="Industry" isopen="true" isSub="false" />} >
         <div>
            <div className="list-group-item form-group p-0 m-0">
                  {this.state.industryData.map((item, i) => (
                    <div className="row col-md-12 p-0 m-0" key={"chkind-"+item.value}>
                      <div className=" col-md-1 mr-1 checkbox"  style={{maxWidth:"25px"}}>
                        <input  className="mr-0"                                
                                 onChange={(e ,type) => this.onChange(e,1,item.label)} 
                                  type='checkbox' 
                                  value={item.value}  checked={item.checked} />
                          </div><div className="col-md-10 p-0 m-0" style={{maxWidth:"80%"}}>
                          <label>  
                              { item.label }
                          </label>
                      </div>
                      </div>
                  ))}
            </div>
            
            </div>
        </Collapsible>
          : ''}
        
        <Collapsible  trigger={<Trigger text="Core Functions" />} triggerWhenOpen={<Trigger text="Core Functions" isopen="true" isSub="false" />} >
            <div>
            <div className="list-group-item form-group p-0 m-0">
                  {this.state.businessData.map((item, i) => (
                     <div className="row col-md-12 p-0 m-0"  key={"chkbus-"+item.value}>
                      <div className=" col-md-1 mr-1 checkbox" style={{maxWidth:"25px"}}>                                                       
                              <input  className="mr-0"                                
                                 onChange={(e,type) => this.onChange(e,2,item.label)} 
                                  type='checkbox' 
                                  value={item.value}  checked={item.checked} />
                                   </div><div className="col-md-10 p-0 m-0" style={{maxWidth:"80%"}}>
                                <label>                      
                              { item.label }
                          </label>
                      </div>
                      </div>
                  ))}
            </div>
            </div>
        </Collapsible>
        <Collapsible  trigger={<Trigger text="Application" />}  triggerWhenOpen={<Trigger text="Application" isopen="true"  isSub="false"/>}>
            <div>
            <div className="list-group-item form-group p-0 m-0">
                  {this.state.applicationData.map((item, i) => (
                     <div className="row col-md-12 p-0 m-0" key={"chkapp-"+item.value}>
                      <div className=" col-md-1 mr-1 checkbox"  style={{maxWidth:"25px"}}>                                                   
                              <input  className="mr-0"                                
                                 onChange={(e,type) => this.onChange(e,3,item.label)} 
                                  type='checkbox' 
                                  value={item.value}  checked={item.checked} />
                                     </div><div className="col-md-10 p-0 m-0" style={{maxWidth:"80%"}}>
                                <label>                          
                              { item.label }
                          </label>
                      </div>
                      </div>
                  ))}
            </div>
            </div>
        </Collapsible>
        <Collapsible  trigger={<Trigger text="Products/Solutions" />}  triggerWhenOpen={<Trigger text="Products/Solutions" isopen="true" isSub="false" />} >
           <div className="list-group-item form-group p-0 m-0">
                {this.state.offeringTypeData.map((item,i) => (
                  <div style={{display:"inline-flex"}} className="" key={"chksub-"+i}>
                      <input  className="mr-0 mt-1"                                
                              onChange={(e) => this.onChange(e,5,item.label)} 
                                  type='checkbox' 
                                  value={item.value}  checked={item.checked} /> 
                            <Collapsible  trigger={<Trigger text={item.label} isSub="true" id={item.value} checked={item.checked} onChange={this.onChange} />}  triggerWhenOpen={<Trigger text={item.label} checked={item.checked} id={item.value} isopen="true" isSub="true" onChange={this.onChange} />} >
                      <div className="list-group-item form-group p-0">
                      {this.state.offeringSubData.map((subitem, j) => (
                      subitem.pid === item.value ?
                      <div className="row col-md-12 p-0 m-0" key={"divsub-"+j}>
                      <div className=" col-md-1 mr-2 checkbox" key={"chksub-"+subitem.pid} style={{maxWidth:"25px"}}>                                                         
                              <input  className="mr-0"                                
                              onChange={(e) => this.onChange(e,4,item.label)} 
                                  type='checkbox' 
                                  value={subitem.value}  checked={subitem.checked} /> 
                            </div>
                            <div className="col-md-10 p-0 m-0" style={{maxWidth:"70%"}}><label>                                                    
                              { subitem.label }
                          </label></div>
                      </div>:''
                      ))}
                      </div>
                      
                      </Collapsible>                    
              </div>
                ))}
          </div>
              </Collapsible>  
         
      </div>
        
      </div>    
       );
  }
  

}
  export default SidebarSub;


